<template>
  <HelpBar />
  <AppBar>
    <router-view />
  </AppBar>
  
</template>

<script setup>
import AppBar from "@/ai_studio/components/layout/AppBar.vue";
import HelpBar from "@/ai_studio/components/layout/HelpBar.vue"
</script>
